import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

interface CmsToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export const CmsToggle: React.FC<CmsToggleProps> = ({
  checked,
  onChange,
  label,
  description,
  disabled = false,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      paddingY={2}
      cursor={disabled ? "not-allowed" : "pointer"}
      onClick={() => {
        if (!disabled) {
          onChange(!checked);
        }
      }}
      style={{ userSelect: "none" }}
    >
      <Box display="flex" flexDirection="column" gap={0.5}>
        <Text size={3} style={{ fontWeight: 500 }}>
          {label}
        </Text>
        {description && (
          <Text size={2} color="default2">
            {description}
          </Text>
        )}
      </Box>

      {/* iOS style Pill Toggle */}
      <div
        style={{
          width: 46,
          height: 26,
          borderRadius: 13,
          backgroundColor: checked ? "#10b981" : "#d1d5db",
          position: "relative",
          transition: "background-color 0.2s ease",
          cursor: disabled ? "not-allowed" : "pointer",
          flexShrink: 0,
          opacity: disabled ? 0.6 : 1,
          boxShadow: checked ? "0 0 0 2px rgba(16, 185, 129, 0.2)" : "none",
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            position: "absolute",
            top: 3,
            left: checked ? 23 : 3,
            transition: "left 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          }}
        />
      </div>
    </Box>
  );
};

export default CmsToggle;
